import { createSagas } from "redux-box";
import swal from "sweetalert2";
import { call, put } from "redux-saga/effects";
import MiscApi from "@s/api/misc";
const errorHandler = err => {
  console.log(err);
  swal("Oops!", err.error_message, "error");
};
const getData = (res) => {
  let result = res.map((el) => {
    el.value = el.name;
    el.label = el.name;
    return el;
  });
  return result;
};
export default createSagas({
  REQUEST_ANALYTICS_STORY: function*() {
    try {
      const res = yield call(MiscApi.getAnalyticsStory);
      if (res.success) {
        swal("Success", res.result.message);
      }
    } catch (err) {
      errorHandler(err);
    }
  },
  REQUEST_PROJECTS_LIST: function*() {
    try {
      const res = yield call(MiscApi.getProjects);

      let result = getData(res.result);

      yield put({
        type: "SET_TIMEKIT_PROJECT_LIST",
        projectList: result,
      });
    } catch (err) {
      errorHandler(err);
    }
  },
  REQUEST_MAGIC_OTP: function* () {
    yield put({ type: "SET_MAGIC_OTP_LOADING", data: true });
    try {
      const res = yield call(MiscApi.getMagicOtp);

      // Backend response can vary; normalize to the OTP value.
      let otp =
        (res &&
          res.result &&
          res.result.otp !== undefined
          ? res.result.otp
          : null) ||
        (res &&
          res.result &&
          res.result.magic_otp !== undefined
          ? res.result.magic_otp
          : null) ||
        (res && res.otp !== undefined ? res.otp : null) ||
        (res && res.magic_otp !== undefined ? res.magic_otp : null);

      if (otp !== null) {
        yield put({ type: "SET_MAGIC_OTP", data: otp });
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_MAGIC_OTP_LOADING", data: false });
    }
  },
  UPDATE_MAGIC_OTP: function* ({ data }) {
    yield put({ type: "SET_MAGIC_OTP_SAVING", data: true });
    try {
      const res = yield call(MiscApi.createOrUpdateMagicOtp, data);

      // Try to update the store with any OTP returned by the backend.
      let otp =
        (res &&
          res.result &&
          res.result.otp !== undefined
          ? res.result.otp
          : null) ||
        (res &&
          res.result &&
          res.result.magic_otp !== undefined
          ? res.result.magic_otp
          : null) ||
        (res && res.otp !== undefined ? res.otp : null) ||
        (res && res.magic_otp !== undefined ? res.magic_otp : null);

      // If backend doesn't return the updated OTP, fall back to the submitted value.
      if (otp === null && data && data.otp !== undefined) {
        otp = data.otp;
      }

      if (res && res.success) {
        swal("Done", (res.result && res.result.message) ? res.result.message : "Magic OTP updated", "success");
      } else if (otp !== null) {
        swal("Done", "Magic OTP updated", "success");
      }

      if (otp !== null) {
        yield put({ type: "SET_MAGIC_OTP", data: otp });
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      yield put({ type: "SET_MAGIC_OTP_SAVING", data: false });
    }
  }
});
